export default "__VITE_ASSET__xXZFm61IvYlyQERHZtyfgQ__"